import URLConfig from '@Config/urls/url.config';
import React from "react";
import { Route } from "react-router-dom";
import * as GabManagementModule from '@Modules/terminalManagementSystem/gabManagement/pages';
import GabManagementRoutes from './gabManagement/GabManagementRoutes';
import * as MerchantModule from '@Modules/terminalManagementSystem/merchant/pages';
import merchantHolderRoutes from './merchant/MerchantRoutes';

const TerminalManagementSystemRoutes = [

  // Debit Routes
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.MERCHANT.ROOT}
    element={<MerchantModule.MerchantLayout />}
  >
    {merchantHolderRoutes.map((dbroute, index) => React.cloneElement(dbroute, { key: index}))}
  </Route>,

  // Prepaid Routes
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.ROOT}
    element={<GabManagementModule.GabManagementLayout />}
  >
    {GabManagementRoutes.map((chroute, index) => React.cloneElement(chroute, { key: index}))}
  </Route>,
];

export default TerminalManagementSystemRoutes;
